<mat-form-field appearance="outline" class="w-auto">
  <mat-select [(value)]="time"
              [compareWith]="compare"
              [placeholder]="placeholder"
              [disabled]="disabled">
    <mat-option *ngFor="let t of times" [value]="t">{{t}}</mat-option>
  </mat-select>
</mat-form-field>
